import { useContext as e } from "react";
import { useTranslation as n } from "react-i18next";
import { defaultNS as r } from "../libs/util/dist/index25.mjs";
import { getUseLocoTranslation as m } from "../libs/util/dist/index28.mjs";
import { LocaleContext as i } from "./context.mjs";
const o = [r], p = () => o, x = m({
  useTranslation: (t, a) => {
    const { i18n: s } = e(i) ?? {};
    return n(t, {
      i18n: s,
      ...a
    });
  },
  defaultNamespaces: o,
  namespaceMapper: p
});
export {
  x as useTranslation
};
